/**
 * ★ 2026-10-22 — Video Verification Pass per territorio (fonte unica per hub IT/ES/EN e landing).
 * Richiesta cliente: aggiungere al Verification Pass ALBANIA i due video
 *   • https://youtu.be/gBdZ_-Y2s6w  «Dallo schermo alla realtà: tre giorni con HCF in Albania» (VP 9–11 ottobre 2026)
 *   • https://youtu.be/nuB7YvUuwMU  «Albania, prima di investire vieni a verificare» (VP 15–17 maggio 2026)
 * Il video storico «cosa faremo» (DEEz5eXicGU) resta come terzo (spiegazione).
 * Titoli = titoli ufficiali dei video YouTube (canale HCF Group), tradotti solo nelle etichette brevi.
 */

export const VP_VIDEOS = {
  AL: [
    {
      id: 'gBdZ_-Y2s6w',
      title: {
        it: 'Dallo schermo alla realtà: tre giorni con HCF in Albania',
        es: 'De la pantalla a la realidad: tres días con HCF en Albania',
        en: 'From the screen to reality: three days with HCF in Albania',
      },
      meta: { it: 'Verification Pass · 9–11 ottobre 2026', es: 'Verification Pass · 9–11 octubre 2026', en: 'Verification Pass · 9–11 October 2026' },
      kind: 'recap',
    },
    {
      id: 'nuB7YvUuwMU',
      title: {
        it: 'Albania, prima di investire vieni a verificare',
        es: 'Albania: antes de invertir, ven a verificar',
        en: 'Albania: before you invest, come and verify',
      },
      meta: { it: 'Verification Pass · 15–17 maggio 2026', es: 'Verification Pass · 15–17 mayo 2026', en: 'Verification Pass · 15–17 May 2026' },
      kind: 'recap',
    },
    {
      id: 'DEEz5eXicGU',
      title: {
        it: 'Verification Pass Albania — cosa faremo',
        es: 'Verification Pass Albania — qué haremos',
        en: 'Verification Pass Albania — what we will do',
      },
      meta: { it: 'Il programma spiegato', es: 'El programa explicado', en: 'The programme explained' },
      kind: 'explainer',
    },
  ],
  ID: [
    {
      id: 'V0Z643ZA4Pg',
      title: { it: 'HCF — The Lombok Journey', es: 'HCF — The Lombok Journey', en: 'HCF — The Lombok Journey' },
      meta: { it: 'Verification Pass · Indonesia', es: 'Verification Pass · Indonesia', en: 'Verification Pass · Indonesia' },
      kind: 'recap',
    },
  ],
  TH: [
    {
      id: 'VvZqwA1ZSOU',
      title: { it: 'HCF — Thailandia', es: 'HCF — Tailandia', en: 'HCF — Thailand' },
      meta: { it: 'Verification Pass · Thailandia', es: 'Verification Pass · Tailandia', en: 'Verification Pass · Thailand' },
      kind: 'recap',
    },
  ],
};

export const vpVideosFor = (territory) => VP_VIDEOS[territory] || VP_VIDEOS.AL;
